module.exports = __webpack_public_path__ + "img/hero-fire-02.5676349b.png";